module.exports = __webpack_public_path__ + "static/media/play.bb828106.svg";